/**
 * Selects Redux state for auth data
 * @param {Object} state Redux state
 */
var getAuthState = function getAuthState(state) {
  return state.auth;
};

var DEFAULT_AUTH_CLAIMS = {};
/**
 * Selects Redux state for parsed JWT claim data
 * @param {Object} state Redux state
 */

var getAuthClaims = function getAuthClaims(state) {
  var authState = getAuthState(state);
  return authState.claims || DEFAULT_AUTH_CLAIMS;
};
/**
 * Finds the jwt claim value for the given claim key
 * @param {Object} state Redux state
 * @param {string} key Claim key to find
 */


var getAuthClaim = function getAuthClaim(state, key) {
  var claims = getAuthClaims(state);
  return claims[key];
};
/**
 * Returns the current JWT refresh token
 * @param {Object} state Redux state
 */


var getAuthRefreshToken = function getAuthRefreshToken(state) {
  var authState = getAuthState(state);
  return authState.refreshToken;
};

export { getAuthClaim, getAuthClaims, getAuthRefreshToken, getAuthState };
